<script setup lang="ts">
const text =
  'Moderní fitness centrum s kvalitním vybavením pro silový i kondiční trénink.';
</script>

<template>
  <div class="flex max-w-88 flex-col xl:max-w-60 2xl:max-w-88">
    <AppLogo size="md" class="self-start" />
    <AppParagraph class="text-client-gray-darker">{{ text }}</AppParagraph>
  </div>
</template>
